import { AdvancedBloc as AdvancedBlocComponent } from './AdvancedBloc.component';
import { connector } from './AdvancedBloc.connector';

export const AdvancedBloc = connector(AdvancedBlocComponent);
